import z from "zod";

const translationPath = "page.4uDlist.generationRule.errors.";

const dataOriginSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "data_origin" },
);

export const generationRuleSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, translationPath + "name"),
  dataOrigin: dataOriginSchema,
});

export type TGenerationRuleForm = z.infer<typeof generationRuleSchema>;
